/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import {MccModule} from '@enisco/mcc-react-lib'
import React from 'react'
import {UserSetting} from '../../../model/userSetting'

export interface ExternalSettingsProps {
  setting: UserSetting
}

const externalSettings: React.FC<ExternalSettingsProps> = ({setting}) => {
  return (
    <MccModule
      name={'name'}
      title={'title'}
      url={setting.url}
      sx={{
          backgroundColor: 'background.paper',
          overflow: 'auto',
          display: 'flex',
          height: '100%',
          width: '100%'
      }}
    />
  )
}

export default externalSettings
